module.exports = __webpack_public_path__ + "media/homelogo.2a36001d.mp4";